module.exports = "\n.btnStyle{\n    bottom: -30px;\n    float: right;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/appkycdetails/appkycdetails.component.css
// module id = ./src/app/appkycdetails/appkycdetails.component.css
// module chunks = main